import React from "react";
import { Outlet, Navigate,useLocation } from "react-router-dom";

export default function PrivateRoute() {
    let userid = localStorage.getItem("token") == null ? false : true;
    let department = parseInt(localStorage.getItem("department"));
    let level = parseInt(localStorage.getItem("level"));

    const location = useLocation();
    const pagename=location.pathname;
    if(userid===false)
    {
        return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
    }else{
        if(level===1)
        {
            if(department===1)
            {  
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management' )
                { 
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2' || pagename==='/salesperson-Information')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
               if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===2)
        {
            if(department===1)
            {
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management' )
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
                if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===3)
        {
            if(department===1)
            {
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
                if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===4)
        {
            if(department===1)
            {
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
                if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===5)
        {
            if(department===1)
            {
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
                if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===6)
        {
            if(department===1)
            {
                if(pagename==='/hr-creation' || pagename==='/create-account' || pagename==='/view-account-management')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===2)
            {
                if(pagename==='/dashboard-sales-vp-of-sales-representative' || pagename==='/salesperson-Information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===3)
            {
                if(pagename==='/merchant-overview' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription' || pagename==='/dashboard-customer2')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===4)
            {
                if(pagename==='/customer-overview' || pagename==='/dashboard-customer2' || pagename==='/dashboard-overview-merchants-information' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                } 
            }else if(department===5)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }else if(department===6)
            {
                if(pagename==='/overview' || pagename==='/merchant-overview' || pagename==='/merchant-subscription')
                {
                    return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
                }else{
                    return <><Navigate to="/" /></>;
                }
            }
        }else if(level===7)
        {
            return <>{userid ? <Outlet /> : <Navigate to="/" />}</>;
        }
    }
}